(function () {
  const cfg = window.Shopperz24 || {};
  const routes = cfg.routes || {};
  const WISHLIST_KEY = 'shopperz24_wishlist';
  const RECENT_SEARCH_KEY = 'shopperz24_recent_searches';
  const RECENTLY_VIEWED_KEY = 'shopperz24_recently_viewed';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents);
    return `₹${(cents / 100).toFixed(0)}`;
  }

  function getWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return raw.map((item) => (typeof item === 'string' ? { id: item, handle: '' } : item));
    } catch {
      return [];
    }
  }

  function setWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    updateWishlistUI();
    refreshWishlistDrawer();
  }

  function updateWishlistUI() {
    const items = getWishlist();
    $$('[data-wishlist-count]').forEach((el) => {
      el.textContent = String(items.length);
      el.hidden = items.length === 0;
    });
    $$('[data-wishlist-toggle]').forEach((btn) => {
      const id = String(btn.dataset.productId);
      const active = items.some((item) => String(item.id) === id);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
      el.dataset.count = String(count);
      if (count === 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });
  }

  function renderFreeShippingBar(container, subtotalCents) {
    if (!container) return;
    const threshold = Number(cfg.freeShippingThreshold || 499) * 100;
    const remaining = Math.max(0, threshold - subtotalCents);
    if (remaining <= 0) {
      container.innerHTML = '<div class="free-shipping-bar">You unlocked <strong>free shipping</strong>!</div>';
      container.hidden = false;
      return;
    }
    const msg = (cfg.strings?.freeShippingRemaining || 'Add {{ amount }} more for free shipping.').replace(
      '{{ amount }}',
      formatMoney(remaining)
    );
    const progress = Math.min(100, Math.round((subtotalCents / threshold) * 100));
    container.innerHTML = `<div class="free-shipping-bar">${msg}<progress max="100" value="${progress}"></progress></div>`;
    container.hidden = false;
  }

  async function fetchCart() {
    const res = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function cartItemHTML(item) {
    const variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-line__variant">${item.variant_title}</p>`
        : '';
    return `
      <article class="cart-line" data-cart-line="${item.key}">
        <a href="${item.url}" class="cart-line__media">
          <img src="${item.image}" alt="" width="80" height="80" loading="lazy">
        </a>
        <div class="cart-line__info">
          <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
          ${variant}
          <p class="cart-line__unit">${formatMoney(item.final_price)} each</p>
          <div class="cart-line__actions">
            <div class="qty-stepper" aria-label="Quantity">
              <button type="button" class="qty-stepper__btn" data-cart-qty-minus data-line-key="${item.key}" aria-label="Decrease quantity">−</button>
              <span class="qty-stepper__value">${item.quantity}</span>
              <button type="button" class="qty-stepper__btn" data-cart-qty-plus data-line-key="${item.key}" aria-label="Increase quantity">+</button>
            </div>
            <p class="cart-line__price">${formatMoney(item.final_line_price)}</p>
          </div>
          <button type="button" class="cart-line__remove" data-cart-remove="${item.key}">Remove</button>
        </div>
      </article>`;
  }

  function showCartToast() {
    const toast = $('[data-cart-toast]');
    if (!toast) return;
    toast.textContent = cfg.strings?.cartAdded || 'Added to cart';
    toast.removeAttribute('hidden');
    toast.classList.add('is-visible');
    clearTimeout(showCartToast._timer);
    showCartToast._timer = setTimeout(() => {
      toast.classList.remove('is-visible');
      toast.setAttribute('hidden', '');
    }, 2400);
  }

  async function refreshCartDrawer() {
    const itemsEl = $('[data-cart-items]');
    const footerEl = $('[data-cart-footer]');
    const subtotalEl = $('[data-cart-subtotal]');
    const totalEl = $('[data-cart-total]');
    const freeBar = $('[data-cart-drawer] [data-free-shipping-bar]');
    const emptyEl = $('[data-cart-empty]');
    const loadingEl = $('[data-cart-loading]');
    const countEl = $('[data-cart-drawer-count]');
    if (!itemsEl) return;

    loadingEl?.removeAttribute('hidden');

    try {
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
      if (countEl) countEl.textContent = cart.item_count ? `(${cart.item_count})` : '';
      renderFreeShippingBar(freeBar, cart.total_price);

      $$('.cart-line', itemsEl).forEach((el) => el.remove());

      if (!cart.item_count) {
        emptyEl?.removeAttribute('hidden');
        footerEl?.setAttribute('hidden', '');
        loadingEl?.setAttribute('hidden', '');
        return;
      }

      emptyEl?.setAttribute('hidden', '');
      cart.items.forEach((item) => {
        itemsEl.insertAdjacentHTML('beforeend', cartItemHTML(item));
      });
      subtotalEl && (subtotalEl.textContent = formatMoney(cart.original_total_price));
      totalEl && (totalEl.textContent = formatMoney(cart.total_price));
      const discountRow = $('[data-cart-discount-row]');
      if (discountRow) {
        discountRow.hidden = !cart.total_discount;
        $('[data-cart-discount-amount]', discountRow).textContent = `−${formatMoney(cart.total_discount)}`;
      }
      const checkoutAmount = $('[data-cart-checkout-amount]');
      checkoutAmount && (checkoutAmount.textContent = formatMoney(cart.total_price));
      renderDiscountCodes(cart);
      footerEl?.removeAttribute('hidden');
    } catch {
      /* noop */
    } finally {
      loadingEl?.setAttribute('hidden', '');
    }
  }

  function wishlistItemHTML(item) {
    const img = item.image
      ? `<img src="${item.image}" alt="" width="72" height="72" loading="lazy">`
      : '<div class="wishlist-line__placeholder"></div>';
    const url = item.url || (item.handle ? `/products/${item.handle}` : '#');
    return `
      <article class="wishlist-line" data-wishlist-line="${item.id}">
        <a href="${url}" class="wishlist-line__media">${img}</a>
        <div class="wishlist-line__info">
          <a href="${url}" class="wishlist-line__title">${item.title || 'Product'}</a>
          ${item.price ? `<p class="wishlist-line__price">${item.price}</p>` : ''}
          <div class="wishlist-line__actions">
            <button type="button" class="btn btn--primary btn--sm" data-wishlist-add-to-cart data-variant-id="${item.variantId || ''}" data-product-id="${item.id}">Add to Cart</button>
            <button type="button" class="wishlist-line__remove" data-wishlist-remove="${item.id}">Remove</button>
          </div>
        </div>
      </article>`;
  }

  function refreshWishlistDrawer() {
    const itemsEl = $('[data-wishlist-items]');
    const emptyEl = $('[data-wishlist-empty]');
    const footerEl = $('[data-wishlist-footer]');
    if (!itemsEl) return;

    const items = getWishlist();
    $$('.wishlist-line', itemsEl).forEach((el) => el.remove());

    if (!items.length) {
      emptyEl?.removeAttribute('hidden');
      footerEl?.setAttribute('hidden', '');
      return;
    }

    emptyEl?.setAttribute('hidden', '');
    items.forEach((item) => itemsEl.insertAdjacentHTML('beforeend', wishlistItemHTML(item)));
    footerEl?.removeAttribute('hidden');
  }

  async function addToCart(formData) {
    const res = await fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    return res.json();
  }

  async function changeLine(key, quantity) {
    $$(`[data-cart-line="${CSS.escape(key)}"]`).forEach((line) => line.classList.add('is-updating'));
    await fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    // Cart page totals are server-rendered, so reload to keep them in sync.
    if ($('[data-cart-page]')) {
      window.location.reload();
      return;
    }
    await refreshCartDrawer();
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = String(value);
    return div.innerHTML.replace(/"/g, '&quot;');
  }

  function renderDiscountCodes(cart) {
    const codes = (cart.discount_codes || []).filter((d) => d.applicable);
    const label = cfg.strings?.removeDiscount || 'Remove coupon [code]';
    $$('[data-cart-discount-list]').forEach((list) => {
      list.innerHTML = codes
        .map(
          (d) => `<li class="cart-discount__code">
            <span>${escapeHtml(d.code)}</span>
            <button type="button" data-cart-discount-remove="${escapeHtml(d.code)}" aria-label="${escapeHtml(label.replace('[code]', d.code))}">×</button>
          </li>`
        )
        .join('');
    });
  }

  async function updateDiscountCodes(codes) {
    const res = await fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    if (!res.ok) throw new Error('Discount update failed');
    return res.json();
  }

  function showDiscountMessage(root, text, isError) {
    const msg = $('[data-cart-discount-message]', root);
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle('is-error', Boolean(isError));
    msg.hidden = !text;
  }

  async function afterDiscountChange() {
    if ($('[data-cart-page]')) {
      window.location.reload();
      return;
    }
    await refreshCartDrawer();
  }

  async function applyDiscount(root) {
    const input = $('[data-cart-discount-input]', root);
    const button = $('[data-cart-discount-apply]', root);
    const code = input?.value.trim();
    if (!code) {
      input?.focus();
      return;
    }
    button && (button.disabled = true);
    showDiscountMessage(root, '');
    try {
      const current = await fetchCart();
      const existing = (current.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
      if (existing.some((c) => c.toLowerCase() === code.toLowerCase())) {
        showDiscountMessage(root, cfg.strings?.discountAlreadyApplied || 'This code is already applied.', true);
        return;
      }
      const cart = await updateDiscountCodes([...existing, code]);
      const added = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      if (!added || !added.applicable) {
        await updateDiscountCodes(existing);
        showDiscountMessage(root, cfg.strings?.discountInvalid || 'This code isn’t valid for your cart.', true);
        return;
      }
      input.value = '';
      showDiscountMessage(root, cfg.strings?.discountApplied || 'Coupon applied!');
      await afterDiscountChange();
    } catch {
      showDiscountMessage(root, cfg.strings?.discountError || 'Could not apply the code. Please try again.', true);
    } finally {
      button && (button.disabled = false);
    }
  }

  async function removeDiscount(code) {
    try {
      const current = await fetchCart();
      const remaining = (current.discount_codes || [])
        .filter((d) => d.applicable && d.code !== code)
        .map((d) => d.code);
      await updateDiscountCodes(remaining);
      await afterDiscountChange();
    } catch {
      /* noop */
    }
  }

  function bindDiscounts() {
    document.addEventListener('click', (e) => {
      const applyBtn = e.target.closest('[data-cart-discount-apply]');
      if (applyBtn) {
        applyDiscount(applyBtn.closest('[data-cart-discount]'));
        return;
      }
      const removeBtn = e.target.closest('[data-cart-discount-remove]');
      if (removeBtn) removeDiscount(removeBtn.dataset.cartDiscountRemove);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || !e.target.matches('[data-cart-discount-input]')) return;
      e.preventDefault();
      applyDiscount(e.target.closest('[data-cart-discount]'));
    });
    if ($('[data-cart-page]')) fetchCart().then(renderDiscountCodes).catch(() => {});
  }

  function openDrawer(drawer) {
    drawer?.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    const focusable = drawer?.querySelector('button, a, input');
    focusable?.focus();
  }

  function closeDrawer(drawer) {
    drawer?.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function bindDrawers() {
    const cartDrawer = $('[data-cart-drawer]');
    $$('[data-cart-open]').forEach((btn) =>
      btn.addEventListener('click', async () => {
        await refreshCartDrawer();
        openDrawer(cartDrawer);
      })
    );
    $$('[data-cart-close]').forEach((btn) => btn.addEventListener('click', () => closeDrawer(cartDrawer)));

    const wishlistDrawer = $('[data-wishlist-drawer]');
    $$('[data-wishlist-open], [data-wishlist-nav]').forEach((btn) =>
      btn.addEventListener('click', (e) => {
        if (btn.tagName === 'A') e.preventDefault();
        refreshWishlistDrawer();
        openDrawer(wishlistDrawer);
      })
    );
    $$('[data-wishlist-close]').forEach((btn) => btn.addEventListener('click', () => closeDrawer(wishlistDrawer)));

    const searchModal = $('[data-search-modal]');
    $$('[data-search-open]').forEach((btn) => openDrawer(searchModal));
    $$('[data-search-close]').forEach((btn) => closeDrawer(searchModal));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeDrawer(cartDrawer);
        closeDrawer(wishlistDrawer);
        closeDrawer(searchModal);
        $('.collection-filters')?.classList.remove('is-open');
        $('[data-mobile-nav]')?.setAttribute('hidden', '');
      }
    });
  }

  function closeMobileNav() {
    const nav = $('[data-mobile-nav]');
    nav?.setAttribute('hidden', '');
    document.body.classList.remove('mobile-nav-open');
    $('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');
  }

  function bindMobileMenu() {
    const nav = $('[data-mobile-nav]');
    $$('[data-mobile-menu-open]').forEach((btn) =>
      btn.addEventListener('click', () => {
        nav?.removeAttribute('hidden');
        document.body.classList.add('mobile-nav-open');
        btn.setAttribute('aria-expanded', 'true');
      })
    );
    $$('[data-mobile-menu-close]').forEach((btn) => btn.addEventListener('click', closeMobileNav));
    nav?.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-open], [data-wishlist-open], [data-cart-open], [data-chat-launcher]')) {
        closeMobileNav();
      }
    });
    nav?.querySelectorAll('.mobile-nav__list a, .mobile-nav__shortcut[href]').forEach((link) => {
      link.addEventListener('click', closeMobileNav);
    });
  }

  function bindCartActions() {
    document.addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        await changeLine(removeBtn.dataset.cartRemove, 0);
        return;
      }
      const minusBtn = e.target.closest('[data-cart-qty-minus]');
      if (minusBtn) {
        const line = minusBtn.closest('[data-cart-line]');
        const qty = Number($('.qty-stepper__value', line)?.textContent || 1);
        await changeLine(minusBtn.dataset.lineKey, Math.max(0, qty - 1));
        return;
      }
      const plusBtn = e.target.closest('[data-cart-qty-plus]');
      if (plusBtn) {
        const line = plusBtn.closest('[data-cart-line]');
        const qty = Number($('.qty-stepper__value', line)?.textContent || 0);
        await changeLine(plusBtn.dataset.lineKey, qty + 1);
        return;
      }
    });

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      const submitter = e.submitter;
      const fd = new FormData(form);
      try {
        await addToCart(fd);
        await refreshCartDrawer();
        if (submitter?.matches('[data-buy-now]')) {
          window.location.href = '/checkout';
          return;
        }
        showCartToast();
        openDrawer($('[data-cart-drawer]'));
      } catch (err) {
        alert(err.message);
      }
    });
  }

  function bindWishlist() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (btn) {
        const id = String(btn.dataset.productId);
        let list = getWishlist();
        const idx = list.findIndex((item) => String(item.id) === id);
        if (idx >= 0) {
          list.splice(idx, 1);
        } else {
          list.push({
            id,
            handle: btn.dataset.productHandle || '',
            variantId: btn.dataset.variantId || '',
            title: btn.dataset.productTitle || '',
            price: btn.dataset.productPrice || '',
            url: btn.dataset.productUrl || '',
            image: btn.dataset.productImage || '',
          });
        }
        setWishlist(list);
        return;
      }

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        const id = removeBtn.dataset.wishlistRemove;
        setWishlist(getWishlist().filter((item) => String(item.id) !== String(id)));
        return;
      }

      const atcBtn = e.target.closest('[data-wishlist-add-to-cart]');
      if (atcBtn) {
        const variantId = atcBtn.dataset.variantId;
        if (!variantId) return;
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        try {
          await addToCart(fd);
          await refreshCartDrawer();
          showCartToast();
          openDrawer($('[data-cart-drawer]'));
        } catch (err) {
          alert(err.message);
        }
      }
    });

    updateWishlistUI();
    refreshWishlistDrawer();
  }

  function bindFooterPanels() {
    const panels = $$('[data-footer-panel]');
    if (!panels.length) return;
    const desktop = window.matchMedia('(min-width: 750px)');
    const sync = () => {
      panels.forEach((panel) => {
        if (desktop.matches) panel.setAttribute('open', '');
        else panel.removeAttribute('open');
      });
    };
    sync();
    desktop.addEventListener('change', sync);
  }

  function bindCollectionUI() {
    const sortSelect = $('[data-collection-sort]');
    sortSelect?.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });

    const closeFilters = () => {
      $('.collection-filters')?.classList.remove('is-open');
      const backdrop = $('[data-filter-backdrop]');
      backdrop?.classList.remove('is-visible');
      backdrop?.setAttribute('hidden', '');
      $('[data-filter-open]')?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    $$('[data-filter-open]').forEach((btn) =>
      btn.addEventListener('click', () => {
        $('.collection-filters')?.classList.add('is-open');
        const backdrop = $('[data-filter-backdrop]');
        backdrop?.removeAttribute('hidden');
        backdrop?.classList.add('is-visible');
        btn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      })
    );
    $$('[data-filter-close]').forEach((btn) => btn.addEventListener('click', closeFilters));
    $('[data-filter-backdrop]')?.addEventListener('click', closeFilters);

    const desktopFilters = window.matchMedia('(min-width: 750px)');
    const syncFilterLayout = () => {
      if (desktopFilters.matches) closeFilters();
    };
    syncFilterLayout();
    desktopFilters.addEventListener('change', syncFilterLayout);
  }

  function bindCarousels() {
    $$('[data-carousel]:not([data-carousel-bound])').forEach((carousel) => {
      carousel.setAttribute('data-carousel-bound', 'true');
      const track = $('[data-carousel-track]', carousel);
      $('[data-carousel-prev]', carousel)?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }));
      $('[data-carousel-next]', carousel)?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }));
    });
  }

  function syncHeroSlideMedia(root) {
    $$('[data-hero-slider-slide]', root).forEach((slide) => {
      const active = slide.classList.contains('is-active');
      $$('.hero-banner__video', slide).forEach((video) => {
        if (active) video.play?.().catch(() => {});
        else {
          video.pause();
          try {
            video.currentTime = 0;
          } catch {
            /* noop */
          }
        }
      });
    });
  }

  function bindHeroSliders() {
    $$('[data-hero-slider]:not([data-hero-slider-bound])').forEach((root) => {
      root.setAttribute('data-hero-slider-bound', 'true');
      const track = $('[data-hero-slider-track]', root);
      const slides = $$('[data-hero-slider-slide]', root);
      if (!track || !slides.length) return;

      syncHeroSlideMedia(root);

      if (slides.length <= 1) return;

      const dots = $$('[data-hero-slider-dot]', root);
      let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (index < 0) index = 0;
      let timer;

      const setSlide = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        syncHeroSlideMedia(root);
      };

      const stopAutoplay = () => {
        if (timer) clearInterval(timer);
        timer = null;
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (root.dataset.autoplay !== 'true') return;
        const ms = Number(root.dataset.autoplayMs || 6000);
        timer = setInterval(() => setSlide(index + 1), ms);
      };

      $('[data-hero-slider-prev]', root)?.addEventListener('click', () => {
        setSlide(index - 1);
        startAutoplay();
      });
      $('[data-hero-slider-next]', root)?.addEventListener('click', () => {
        setSlide(index + 1);
        startAutoplay();
      });
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          setSlide(Number(dot.dataset.heroSliderDot || 0));
          startAutoplay();
        });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      setSlide(index);
      startAutoplay();
    });
  }

  function bindReviewVideos() {
    const players = $$('[data-review-video]');
    players.forEach((video) => {
      video.addEventListener('play', () => {
        players.forEach((other) => {
          if (other !== video && !other.paused) other.pause();
        });
      });
    });
  }

  function bindCountdown() {
    $$('[data-flash-deals]').forEach((section) => {
      const deadline = section.dataset.deadline;
      if (!deadline) return;
      const end = new Date(deadline).getTime();
      const daysEl = $('[data-countdown-days]', section);
      const hoursEl = $('[data-countdown-hours]', section);
      const minsEl = $('[data-countdown-minutes]', section);
      const secsEl = $('[data-countdown-seconds]', section);
      const tick = () => {
        const diff = Math.max(0, end - Date.now());
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function saveRecentlyViewedFromPage() {
    const page = $('[data-product-page]');
    if (!page) return;
    const id = page.dataset.productId;
    if (!id) return;
    const entry = {
      id,
      handle: page.dataset.productHandle || '',
      title: page.dataset.productTitle || '',
      url: page.dataset.productUrl || '',
      image: page.dataset.productImage || '',
      price: Number(page.dataset.productPrice || 0),
      priceFormatted: page.dataset.productPriceFormatted || '',
    };
    let items = [];
    try {
      items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch {
      items = [];
    }
    items = items.filter((item) => String(item.id) !== String(id));
    items.unshift(entry);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items.slice(0, 12)));
  }

  function updatePriceCompare(ourPriceCents) {
    const root = $('[data-price-compare]');
    if (!root) return;
    const ourEl = $('[data-price-compare-our]', root);
    if (ourEl) ourEl.textContent = formatMoney(ourPriceCents);
    root.dataset.ourPrice = String(ourPriceCents);
    let maxOther = 0;
    $$('[data-other-price]', root).forEach((row) => {
      const other = Number(row.dataset.otherPrice || 0);
      if (other > maxOther) maxOther = other;
    });
    const saveEl = $('[data-price-compare-save]', root);
    if (!saveEl) return;
    if (maxOther > ourPriceCents) {
      const save = maxOther - ourPriceCents;
      const pct = Math.round((save / maxOther) * 100);
      saveEl.textContent = `You save up to ${formatMoney(save)} (${pct}%) vs other platforms`;
      saveEl.hidden = false;
    } else {
      saveEl.hidden = true;
    }
  }

  function bindProductReviews() {
    const root = $('[data-product-reviews]');
    if (!root) return;
    const list = $('[data-review-list]', root);
    if (!list) return;
    const cards = $$('[data-review-card]', list);
    const sort = $('[data-review-sort]', root);

    const apply = () => {
      const sortMode = sort?.value || 'newest';
      cards.forEach((card) => {
        card.hidden = false;
      });
      const visible = [...cards];
      visible.sort((a, b) => {
        if (sortMode === 'rating') return Number(b.dataset.rating) - Number(a.dataset.rating);
        return Number(a.dataset.sortIndex) - Number(b.dataset.sortIndex);
      });
      visible.forEach((card) => list.appendChild(card));
    };

    sort?.addEventListener('change', apply);
  }

  function bindRecentlyViewed() {
    const section = $('[data-recently-viewed-section]');
    const track = $('[data-recently-viewed-track]');
    if (!section || !track) return;
    const page = $('[data-product-page]');
    const currentId = page?.dataset.productId;
    const limit = Number(section.dataset.recentLimit || 8);
    let items = [];
    try {
      items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch {
      items = [];
    }
    items = items.filter((item) => String(item.id) !== String(currentId)).slice(0, limit);
    if (!items.length) {
      section.hidden = true;
      return;
    }
    section.hidden = false;
    track.innerHTML = items
      .map(
        (item) => `
      <div class="carousel__slide">
        <article class="recent-product-card">
          <a href="${item.url || `/products/${item.handle}`}" tabindex="-1" aria-hidden="true">
            ${
              item.image
                ? `<img class="recent-product-card__image" src="${item.image}" alt="" loading="lazy" width="240" height="240">`
                : `<div class="recent-product-card__image"></div>`
            }
          </a>
          <div class="recent-product-card__body">
            <h3 class="recent-product-card__title"><a href="${item.url || `/products/${item.handle}`}">${item.title || 'Product'}</a></h3>
            <p class="recent-product-card__price">${item.priceFormatted || formatMoney(item.price || 0)}</p>
          </div>
        </article>
      </div>`
      )
      .join('');
    bindCarousels();
  }

  function formatOrdinalDate(date) {
    const day = date.getDate();
    const mod10 = day % 10;
    const mod100 = day % 100;
    let suffix = 'th';
    if (mod10 === 1 && mod100 !== 11) suffix = 'st';
    else if (mod10 === 2 && mod100 !== 12) suffix = 'nd';
    else if (mod10 === 3 && mod100 !== 13) suffix = 'rd';
    const weekday = date.toLocaleDateString('en-IN', { weekday: 'short' });
    const month = date.toLocaleDateString('en-IN', { month: 'short' });
    return `${weekday}, ${month} ${day}${suffix}`;
  }

  function updateProductStock(variant) {
    const root = $('[data-product-stock]');
    if (!root || !variant) return;
    const cap = Number(root.dataset.stockCap || 30);
    const tracked = variant.inventory_management === 'shopify';
    const qty = Number(variant.inventory_quantity ?? 0);
    const qtyEl = $('[data-stock-qty]', root);
    const fillEl = $('[data-stock-fill]', root);
    if (!tracked || qty <= 0 || !variant.available) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    if (qtyEl) qtyEl.textContent = String(qty);
    if (fillEl) {
      const pct = Math.min(100, (qty / cap) * 100);
      fillEl.style.width = `${pct}%`;
    }
  }

  function bindDeliveryEstimate() {
    const el = $('[data-delivery-estimate]');
    if (!el) return;
    const min = Number(el.dataset.deliveryMin || 3);
    const max = Number(el.dataset.deliveryMax || 6);
    const from = new Date();
    const to = new Date();
    from.setDate(from.getDate() + min);
    to.setDate(to.getDate() + max);
    const fromEl = $('[data-delivery-from]', el);
    const toEl = $('[data-delivery-to]', el);
    if (fromEl) fromEl.textContent = formatOrdinalDate(from);
    if (toEl) toEl.textContent = formatOrdinalDate(to);
  }

  function bindBundleOptions() {
    const qtyInput = $('[data-product-quantity]');
    const options = $$('[data-bundle-option]');
    if (!options.length || !qtyInput) return;
    const syncSelected = () => {
      options.forEach((label) => {
        const input = $('input[type="radio"]', label);
        const selected = Boolean(input?.checked);
        label.classList.toggle('is-selected', selected);
        if (selected && input) qtyInput.value = input.value;
      });
    };
    options.forEach((label) => {
      $('input[type="radio"]', label)?.addEventListener('change', syncSelected);
      label.addEventListener('click', () => {
        const input = $('input[type="radio"]', label);
        if (input) {
          input.checked = true;
          syncSelected();
        }
      });
    });
    syncSelected();
  }

  function updateBundlePricing(unitPrice) {
    $$('[data-bundle-option]').forEach((label) => {
      const input = $('input[type="radio"]', label);
      if (!input) return;
      const qty = Number(input.dataset.bundleQty || 1);
      const compare = Number(input.dataset.bundleCompare || 0);
      const line = unitPrice * qty;
      const priceEl = $('[data-bundle-line-price]', label);
      const compareEl = $('[data-bundle-line-compare]', label);
      if (priceEl) priceEl.textContent = formatMoney(line);
      if (compareEl && compare > line) compareEl.textContent = formatMoney(compare);
    });
  }

  function bindProductQuotes() {
    const root = $('[data-product-quotes]');
    if (!root) return;
    const slides = $$('[data-quote-slide]', root);
    const dotsHost = $('[data-quote-dots]', root);
    if (!slides.length || !dotsHost) return;
    let active = 0;
    const dots = slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'product-quote-slider__dot';
      dot.setAttribute('aria-label', `Show review highlight ${i + 1}`);
      dotsHost.appendChild(dot);
      return dot;
    });
    const show = (index) => {
      active = index;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    show(0);
    let timer = window.setInterval(() => show((active + 1) % slides.length), 7000);
    root.addEventListener('mouseenter', () => window.clearInterval(timer));
  }

  function productGallerySrcset(src) {
    if (!src) return '';
    const widths = [400, 600, 800, 1000, 1200];
    const withWidth = (url, w) => {
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, `$1${w}`);
      return `${url}${url.includes('?') ? '&' : '?'}width=${w}`;
    };
    return widths.map((w) => `${withWidth(src, w)} ${w}w`).join(', ');
  }

  function setProductGalleryImage(img, src, alt) {
    if (!img || !src) return;
    img.src = src;
    img.srcset = productGallerySrcset(src);
    if (alt != null) img.alt = alt;
  }

  function bindProductPage() {
    saveRecentlyViewedFromPage();
    updatePriceCompare(Number($('[data-product-page]')?.dataset.productPrice || 0));
    bindDeliveryEstimate();
    bindBundleOptions();
    bindProductQuotes();

    const productJsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!productJsonEl) return;
    let product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch {
      return;
    }

    const variantInput = $('[data-variant-id]');
    const priceMount = $('[data-product-price]');
    const mainImage = $('#ProductMainImage');
    const initialVariant = product.variants.find((v) => String(v.id) === String(variantInput?.value)) || product.variants[0];
    updateProductStock(initialVariant);

    function findVariant(selections) {
      return product.variants.find((v) => v.options.every((opt, i) => opt === selections[i]));
    }

    $$('[data-variant-option]').forEach((select, index) => {
      select.addEventListener('change', () => {
        const selections = $$('[data-variant-option]').map((el) => el.value);
        const variant = findVariant(selections);
        if (!variant) return;
        variantInput.value = variant.id;
        const atc = $('[data-add-to-cart]');
        if (atc) {
          atc.disabled = !variant.available;
          atc.textContent = variant.available ? cfg.strings?.addToCart || 'Add to Cart' : cfg.strings?.soldOut || 'Sold out';
        }
        if (priceMount) {
          const compare = variant.compare_at_price;
          const price = variant.price;
          if (compare > price) {
            const discount = Math.round(((compare - price) / compare) * 100);
            priceMount.innerHTML = `<div class="price price--on-sale"><s class="price__compare">${formatMoney(compare)}</s><span class="price__current">${formatMoney(price)}</span><span class="price__discount">${discount}% OFF</span></div>`;
          } else {
            priceMount.innerHTML = `<div class="price"><span class="price__current">${formatMoney(price)}</span></div>`;
          }
        }
        updatePriceCompare(variant.price);
        updateBundlePricing(variant.price);
        updateProductStock(variant);
        const mediaId = variant.featured_media?.id;
        if (mediaId && mainImage) {
          const thumb = $$('[data-gallery-thumb]').find((b) => String(b.dataset.mediaId) === String(mediaId));
          if (thumb?.dataset.mediaSrc) {
            setProductGalleryImage(mainImage, thumb.dataset.mediaSrc, thumb.dataset.mediaAlt || product.title);
            $$('[data-gallery-thumb]').forEach((b) => b.classList.toggle('is-active', b === thumb));
          }
        }
      });
    });

    $$('[data-gallery-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.dataset.mediaSrc;
        if (!src || !mainImage) return;
        setProductGalleryImage(mainImage, src, btn.dataset.mediaAlt || product.title);
        $$('[data-gallery-thumb]').forEach((b) => b.classList.toggle('is-active', b === btn));
      });
    });

    mainImage?.addEventListener('click', () => {
      if (!document.fullscreenEnabled) return;
      mainImage.requestFullscreen?.();
    });

    const stickyBar = $('[data-sticky-atc]');
    const stickyBtn = $('[data-sticky-add-to-cart]');
    const mainForm = $('[data-product-form]');
    if (stickyBar && mainForm) {
      const syncStickyAtc = (formVisible) => {
        if (formVisible) {
          stickyBar.setAttribute('hidden', '');
          document.body.classList.remove('product-sticky-atc-visible');
        } else {
          stickyBar.removeAttribute('hidden');
          document.body.classList.add('product-sticky-atc-visible');
        }
      };
      const observer = new IntersectionObserver(
        ([entry]) => syncStickyAtc(entry.isIntersecting),
        { threshold: 0.01 }
      );
      observer.observe(mainForm);
      stickyBtn?.addEventListener('click', () => $('[data-add-to-cart]', mainForm)?.click());
    }
  }

  function saveRecentSearch(term) {
    if (!term || term.length < 2) return;
    let recent = [];
    try {
      recent = JSON.parse(localStorage.getItem(RECENT_SEARCH_KEY) || '[]');
    } catch {
      recent = [];
    }
    recent = [term, ...recent.filter((t) => t !== term)].slice(0, 5);
    localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(recent));
  }

  function renderRecentSearches() {
    const wrap = $('[data-search-recent]');
    const list = $('[data-search-recent-list]');
    if (!wrap || !list) return;
    let recent = [];
    try {
      recent = JSON.parse(localStorage.getItem(RECENT_SEARCH_KEY) || '[]');
    } catch {
      recent = [];
    }
    if (!recent.length) return;
    wrap.hidden = false;
    list.innerHTML = recent
      .map((term) => `<li><a href="${routes.search_url}?q=${encodeURIComponent(term)}">${term}</a></li>`)
      .join('');
  }

  let searchTimer;
  function bindPredictiveSearch() {
    renderRecentSearches();
    const input = $('[data-predictive-search-input]');
    const results = $('[data-predictive-search-results]');
    if (!input || !results || !routes.predictive_search_url) return;

    input.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = input.value.trim();
      if (q.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(async () => {
        const url = `${routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
        try {
          const res = await fetch(url);
          const html = await res.text();
          results.innerHTML = html;
          results.hidden = false;
        } catch {
          results.hidden = true;
        }
      }, 220);
    });

    input.closest('form')?.addEventListener('submit', () => saveRecentSearch(input.value.trim()));
  }

  function bindChatWidget() {
    const root = $('[data-chat-widget]');
    if (!root) return;

    const panel = $('[data-chat-panel]', root);
    const closeBtn = $('[data-chat-close]', root);
    const cartBtn = $('[data-chat-cart]', root);
    const form = $('[data-chat-form]', root);
    const input = $('[data-chat-input]', root);
    const sendBtn = $('[data-chat-send]', root);
    const messages = $('[data-chat-messages]', root);
    const quickWrap = $('[data-chat-quick-wrap]', root);
    const quickToggle = $('[data-chat-quick-toggle]', root);
    const welcomeTemplate = $('[data-chat-welcome-template]');
    const CHAT_STORE_KEY = 'shopperz24_chat_thread_v1';

    let config = {};
    try {
      config = JSON.parse($('[data-chat-config]')?.textContent || '{}');
    } catch {
      config = {};
    }

    let busy = false;

    const setLaunchersExpanded = (expanded) => {
      $$('[data-chat-launcher]').forEach((btn) => btn.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
    };

    const open = () => {
      panel?.removeAttribute('hidden');
      setLaunchersExpanded(true);
      ensureWelcome();
      restoreThread();
      window.setTimeout(() => input?.focus(), 50);
    };

    const close = () => {
      panel?.setAttribute('hidden', '');
      setLaunchersExpanded(false);
    };

    const scrollMessages = () => {
      if (!messages) return;
      messages.scrollTop = messages.scrollHeight;
    };

    const appendBubble = (text, type, html) => {
      if (!messages || (!text && !html)) return;
      const bubble = document.createElement('div');
      bubble.className = `chat-widget__bubble chat-widget__bubble--${type}`;
      if (html) bubble.innerHTML = html;
      else bubble.textContent = text;
      messages.appendChild(bubble);
      scrollMessages();
      persistThread();
      return bubble;
    };

    const removeTyping = () => {
      messages?.querySelector('[data-chat-typing]')?.remove();
    };

    const showTyping = () => {
      removeTyping();
      const bubble = document.createElement('div');
      bubble.className = 'chat-widget__bubble chat-widget__bubble--typing';
      bubble.dataset.chatTyping = 'true';
      bubble.textContent = 'Shopperz24 Expert is typing…';
      messages?.appendChild(bubble);
      scrollMessages();
    };

    const persistThread = () => {
      if (!messages) return;
      const items = $$('.chat-widget__bubble', messages)
        .filter((el) => !el.dataset.chatSeed && !el.dataset.chatTyping)
        .map((el) => ({
          type: el.classList.contains('chat-widget__bubble--user') ? 'user' : 'bot',
          html: el.innerHTML,
        }));
      try {
        sessionStorage.setItem(CHAT_STORE_KEY, JSON.stringify(items.slice(-40)));
      } catch {
        /* noop */
      }
    };

    const restoreThread = () => {
      if (!messages) return;
      let items = [];
      try {
        items = JSON.parse(sessionStorage.getItem(CHAT_STORE_KEY) || '[]');
      } catch {
        items = [];
      }
      if (!items.length) return;
      $$('.chat-widget__bubble', messages)
        .filter((el) => !el.dataset.chatSeed)
        .forEach((el) => el.remove());
      items.forEach((item) => appendBubble('', item.type, item.html));
    };

    const ensureWelcome = () => {
      if (!messages || messages.querySelector('[data-chat-seed]')) return;
      if (welcomeTemplate?.content) {
        messages.appendChild(welcomeTemplate.content.cloneNode(true));
      } else {
        if (config.welcome) appendBubble(config.welcome, 'bot');
        if (config.safetyNote) {
          const note = appendBubble(config.safetyNote, 'bot');
          note?.classList.add('chat-widget__bubble--note');
        }
      }
      scrollMessages();
    };

    const link = (href, label) => `<a href="${href}">${label}</a>`;

    const botReply = (userText) => {
      const q = userText.toLowerCase().trim();
      let replyHtml =
        'Thanks for reaching out. Tap a quick topic below or use <strong>Click here to support</strong> for human help.';

      if (/^(hi+|hello+|hey+|hii+|namaste)/.test(q)) {
        replyHtml =
          'Hello! 👋 How can I help you today? Try <strong>Track order</strong>, <strong>Returns</strong>, or ask about <strong>COD & payment</strong>.';
      } else if (/track|order status|where is my order|delivery status/.test(q)) {
        replyHtml = `Track live orders from ${link(config.accountUrl || '/account', 'your account')}. After login, open the order for tracking updates.`;
      } else if (/return|refund|exchange|replace/.test(q)) {
        replyHtml = `Returns & exchanges: see our ${link(config.refundPolicyUrl || '/policies/refund-policy', 'return policy')}. You can also use the support button below.`;
      } else if (/ship|shipping|deliver|when will i get/.test(q)) {
        replyHtml = `Delivery timelines depend on your pincode at checkout. Read ${link(config.shippingPolicyUrl || '/policies/shipping-policy', 'shipping policy')}.`;
      } else if (/cod|cash on delivery|payment|paytm|upi|phonepe|gpay|card/.test(q)) {
        replyHtml =
          'We support UPI, cards, wallets & COD on eligible orders. Shopperz24 never asks for OTP or extra delivery fees by phone—ignore such calls.';
      } else if (/price|discount|offer|coupon|deal/.test(q)) {
        replyHtml = `Prices update on each product page. Browse ${link(config.collectionsUrl || '/collections', 'all collections')} or check Flash deals for offers.`;
      } else if (/product|buy|shop|catalog|collection/.test(q)) {
        replyHtml = `Browse products here: ${link(config.collectionsUrl || '/collections', 'Shop all')}. Tell us the product name if you need help choosing.`;
      } else if (/contact|call|phone|email|support|human|agent/.test(q)) {
        if (config.whatsappUrl) {
          replyHtml = `Chat with us on WhatsApp: ${link(config.whatsappUrl, 'Open WhatsApp support')}. Or use ${link(config.supportUrl || '/pages/contact', 'contact form')}.`;
        } else if (config.shopEmail) {
          replyHtml = `Email us at ${link(`mailto:${config.shopEmail}`, config.shopEmail)} or ${link(config.supportUrl || '/pages/contact', 'contact page')}.`;
        } else {
          replyHtml = `Reach our team via ${link(config.supportUrl || '/pages/contact', 'contact support')}.`;
        }
      } else if (/thank|thanks|ok|okay|cool/.test(q)) {
        replyHtml = 'Happy to help! If you need anything else, just message here anytime.';
      }

      showTyping();
      window.setTimeout(() => {
        removeTyping();
        appendBubble('', 'bot', replyHtml);
        busy = false;
        sendBtn?.removeAttribute('disabled');
        input?.removeAttribute('disabled');
      }, config.replyDelayMs || 700);
    };

    const sendUserMessage = (text) => {
      if (busy) return;
      const trimmed = text.trim();
      if (!trimmed) return;
      busy = true;
      sendBtn?.setAttribute('disabled', '');
      input?.setAttribute('disabled', '');
      appendBubble(trimmed, 'user');
      botReply(trimmed);
    };

    $$('[data-chat-launcher]').forEach((btn) => btn.addEventListener('click', open));
    closeBtn?.addEventListener('click', close);
    cartBtn?.addEventListener('click', () => {
      close();
      $('[data-cart-open]')?.click();
    });

    quickToggle?.addEventListener('click', () => {
      const openQuick = quickWrap?.hasAttribute('hidden');
      if (openQuick) {
        quickWrap?.removeAttribute('hidden');
        quickToggle.setAttribute('aria-expanded', 'true');
      } else {
        quickWrap?.setAttribute('hidden', '');
        quickToggle.setAttribute('aria-expanded', 'false');
      }
    });

    $$('[data-chat-quick]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.chatQuick;
        if (key === 'track') sendUserMessage('How do I track my order?');
        else if (key === 'return') sendUserMessage('I need help with a return or exchange.');
        else if (key === 'cod') sendUserMessage('Do you offer COD and UPI payment?');
        else if (key === 'help') {
          sendUserMessage('I want to talk to support.');
          if (config.whatsappUrl) {
            window.setTimeout(() => {
              appendBubble('', 'bot', `Opening WhatsApp… ${link(config.whatsappUrl, 'Continue in WhatsApp')}`);
              window.open(config.whatsappUrl, '_blank', 'noopener,noreferrer');
            }, 500);
          } else {
            window.setTimeout(() => {
              appendBubble('', 'bot', `Please use ${link(config.supportUrl || '/pages/contact', 'contact support')} and we will reply soon.`);
            }, 500);
          }
        }
      });
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const value = input?.value || '';
      input.value = '';
      sendUserMessage(value);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel && !panel.hasAttribute('hidden')) close();
    });
  }

  function initCartPageFreeShipping() {
    $$('[data-free-shipping-bar]').forEach(async (bar) => {
      if (bar.closest('[data-cart-drawer]')) return;
      try {
        const cart = await fetchCart();
        renderFreeShippingBar(bar, cart.total_price);
      } catch {
        /* noop */
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindDrawers();
    bindMobileMenu();
    bindCartActions();
    bindDiscounts();
    bindWishlist();
    bindCollectionUI();
    bindFooterPanels();
    bindCarousels();
    bindHeroSliders();
    bindReviewVideos();
    bindCountdown();
    bindProductPage();
    bindProductReviews();
    bindRecentlyViewed();
    bindPredictiveSearch();
    initCartPageFreeShipping();
    refreshCartDrawer();
    bindChatWidget();
  });
})();
